import React , { useState } from 'react';
import Text from '../../../../../../global/text/text';
import {FormattedMessage} from 'react-intl';
import { CustomFieldsOptionsListDTO, RestrictAccessFilter } from '../../../../../../../api/custom-pages.dao';
import classnames from 'classnames';
import ChevronSVG from '../../../../../../../images/svg/icons8-expand-arrow';
import './access-filter-container.scss';
import { getFilterNamesByFilterType } from '../../../../../../../infrastructure/utils/passport.utils';
import { REMOVE_TEXT } from '../../../../../../../constants/common-labels.constants';
import { noneAsNullOrUndefined } from './restrict-access-container';

export interface IAccessFilterProps {
    name: string;
    filter: RestrictAccessFilter;
    onDelete: () => void;
    customFieldsOptionsList: CustomFieldsOptionsListDTO[];
}

const allowedFilterTypes = {
    allowedOrganizationTypes: 'Organization Type',
    allowedAttendanceMethods: 'Attendance Method',
};

const AccessFilter: React.FunctionComponent<IAccessFilterProps> = props => {
    const {name, filter, onDelete, customFieldsOptionsList = []} = props;
    const [expanded, setExpanded] = useState(false);

    const {allowedOptions = {}, ...restFilters} = filter;

    return (
        <>
            <div className='access-filter list__wrapper p-left-5px'>
                <div className='access-filter__item list__item' onClick={() => setExpanded(!expanded)}>
                    <Text className='access-filter__name' tag='p' message={name} />
                    <div className={classnames(
                        'oe-icon', 'oe-icon__svg', 'expand-arrow',
                        { 'expand-arrow__up': expanded }
                    )}>
                        <ChevronSVG />
                    </div>
                </div>
                <label
                    onClick={() => onDelete()}
                    className='list__wrapper__remove-label'
                >
                    <FormattedMessage {...REMOVE_TEXT}/>
                </label>
            </div>
            {expanded && <>
                {Object.entries(restFilters).map(([type, filters], index) => {
                    const filterType = allowedFilterTypes[type];
                    const filterNames = getFilterNamesByFilterType(type as keyof RestrictAccessFilter, filters);
                   if (!filters.length) return null;

                    const isOrganizationTypeFilter = type === 'allowedOrganizationTypes';
                    const hasNoneValue = isOrganizationTypeFilter && filters.includes(noneAsNullOrUndefined);

                    const renderFilterName = (filterName: string, i: number) => {
                        const isLastItem = i === filterNames.length - 1;
                        const isNoneLabel = filterName === '<i>None</i>';
                        return (
                            <React.Fragment key={`${filterName}-${i}`}>
                                {hasNoneValue && isNoneLabel ? <em>None</em> : filterName}
                                {!isLastItem && ', '}
                            </React.Fragment>
                        );
                    };

                    return (
                        <div key={index} className='list__wrapper'>
                            <div className='list__item overflow-ellipsis'>
                                <p className='overflow-ellipsis'>
                                    {filterType}: {filterNames.map(renderFilterName)}
                                </p>
                            </div>
                        </div>
                    );
                })}
                {!!Object.keys(allowedOptions).length && Object.entries(allowedOptions).map(([type, filters], index) => {
                    const filterName = customFieldsOptionsList.find(field => field.customFieldId.toString() === type)?.label;
                    if (filters.length) {
                        return <div key={index} className='list__wrapper'>
                            <div className='list__item'>
                                <Text tag='p' message={filterName + ': ' + filters.join(', ')} withEllipsis/>
                            </div>
                        </div>;
                    }
                })}
            </>}
        </>
    );
};

export { AccessFilter };
